import React, { useState, useRef, useEffect } from 'react';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'react-bootstrap/Dropdown';
import PropTypes from 'prop-types';
import '../../../../assignments/assignments.scss';

const StandardPrintingContent = ({
  updateSettings,
  assignmentName,
  fontStyleData,
  fontSizeData,
  questionDetails,
  mcSpacingData,
  mcStylingData,
  teacherNameData,
  answerKey,
  dueDate,
  initialInstructions,
  settingsData,
  gotoId
}) => {
  const [showHeaderOptions, setShowHeaderOptions] = useState(false);
  const [showQuestionLayout, setShowQuestionLayout] = useState(false);
  const [showName, setShowName] = useState(true);
  const [showClass, setShowClass] = useState(true);
  const [showAssignment, setShowAssignment] = useState(true);
  const [showTeacher, setShowTeacher] = useState(true);
  const [clickedMenuItem, setClickedMenuItem] = useState(false);
  const [fontStyleClass, setFontStyleClass] = useState('');
  const [MCSpacingClass, setMCSpacingClass] = useState('');
  const [MCStylingClass, setMCStylingClass] = useState('');
  const [answerKeyClass, setAnswerKeyClass] = useState('');
  const [teacherNameValue, setTeacherNameValue] = useState('');
  const [dueDateValue, setDueDateValue] = useState('');
  const [instructionsValue, setInstructionsValue] = useState('');
  const questionsContainerRef = useRef(null);

  const [headerOptions, setHeaderOptions] = useState([
    {
      id: 'hideName',
      name: 'Name',
      toggleName: 'Show Name'
    },
    {
      id: 'hideClass',
      name: 'Class',
      toggleName: 'Show Class'
    },
    {
      id: 'hideAssignment',
      name: 'Assignment',
      toggleName: 'Show Assignment'
    },
    {
      id: 'hideTeacher',
      name: 'Teacher',
      toggleName: 'Show Teacher'
    }
  ]);

  const questionLayout = [
    {
      id: 'answerBelow',
      name: 'Answer Space Below'
    },
    {
      id: 'toggleOptions',
      name: 'MC Toggle Options'
    },
    {
      id: 'removeAnswer',
      name: 'Remove Answer Space'
    },
    {
      id: 'stackLeft',
      name: 'Stack Left (2 column)'
    },
    {
      id: 'pageBreakAbove',
      name: 'Page Break Above'
    },
    {
      id: 'stackRight',
      name: 'Stack Right (2 column)'
    },
    {
      id: 'pageBreakBelow',
      name: 'Page Break Below'
    },
    {
      id: 'exclude',
      name: 'Exclude'
    },
    {
      id: 'ruleLine',
      name: 'Remove Rule Line'
    },
    {
      id: 'reset',
      name: 'Reset Images'
    },
    {
      id: 'workSpace',
      name: 'Remove WorkSpace'
    },
    {
      id: 'gotoThump',
      name: 'Go To Thumb'
    }
  ];

  const handleQuestionLayout = () => {
    setShowQuestionLayout(!showQuestionLayout);
  };

  const handleHeaderOptions = () => {
    setShowHeaderOptions(!showHeaderOptions);
  };

  const handleMenuItem = () => {
    setClickedMenuItem(!clickedMenuItem);
  };

  const handleHeaderMenuItem = (id) => {
    switch (id) {
    case 'hideName':
      setShowName(!showName);
      updateSettings({ showName: !showName });
      break;
    case 'hideClass':
      setShowClass(!showClass);
      updateSettings({ showClass: !showClass });
      break;
    case 'hideAssignment':
      setShowAssignment(!showAssignment);
      updateSettings({ showAssignment: !showAssignment });
      break;
    case 'hideTeacher':
      setShowTeacher(!showTeacher);
      updateSettings({ showTeacher: !showTeacher });
      break;
    }
    setHeaderOptions((prevOptions) =>
      prevOptions.map((item) => (item.id === id ? { ...item, visible: !item.visible } : item))
    );
  };

  const handleFontStyle = () => {
    switch (fontStyleData) {
    case 'Times New Roman':
      setFontStyleClass('times');
      break;
    case 'arial':
      setFontStyleClass('arial');
      break;
    case 'comic Sans MS':
      setFontStyleClass('comic-sans');
      break;
    case 'Courier':
      setFontStyleClass('courier');
      break;
    case 'Tahoma':
      setFontStyleClass('tahoma');
      break;
    case 'Verdana':
      setFontStyleClass('verdana');
      break;
    default:
      setFontStyleClass('times');
      break;
    }
  };

  const handleMCSpacing = () => {
    switch (mcSpacingData) {
    case 1:
      setMCSpacingClass('full-space');
      break;
    case 15:
      setMCSpacingClass('one-half-space');
      break;
    case 2:
      setMCSpacingClass('double-space');
      break;
    default:
      setMCSpacingClass('full-space');
      break;
    }
  };

  const handleMCStyling = () => {
    switch (mcStylingData) {
    case 0:
      setMCStylingClass('decimal');
      break;
    case 1:
      setMCStylingClass('lower');
      break;
    case 2:
      setMCStylingClass('upper');
      break;
    case 3:
      setMCStylingClass('decimal-dot');
      break;
    case 4:
      setMCStylingClass('lower-dot');
      break;
    case 5:
      setMCStylingClass('upper-dot');
      break;
    case 6:
      setMCStylingClass('upper-enclosed');
      break;
    default:
      setMCStylingClass('decimal');
      break;
    }
  };

  const handleAnswerKey = () => {
    switch (answerKey) {
    case 0:
      setAnswerKeyClass('d-none');
      break;
    case 1:
      setAnswerKeyClass('d-flex flex-wrap');
      break;
    case 2:
      setAnswerKeyClass('d-block');
      break;
    default:
      setAnswerKeyClass('d-none');
      break;
    }
  };

  const handleTeacherEdit = (event) => {
    setTeacherNameValue(event.target.value);
    updateSettings({ teacherName: event.target.value });
  };

  const handleDueDateEdit = (event) => {
    setDueDateValue(event.target.value);
    updateSettings({ dueDate: event.target.value });
  };

  const handleInstructionsEdit = (event) => {
    setInstructionsValue(event.target.value);
    updateSettings({ instructions: event.target.value });
  };

  useEffect(() => {
    handleFontStyle();
  }, [fontStyleData]);

  useEffect(() => {
    handleMCSpacing();
  }, [mcSpacingData]);

  useEffect(() => {
    handleMCStyling();
  }, [mcStylingData]);

  useEffect(() => {
    handleAnswerKey();
  }, [answerKey]);

  useEffect(() => {
    setTeacherNameValue(teacherNameData);
    setInstructionsValue(initialInstructions);
    setDueDateValue(dueDate);
    setShowName(settingsData.showName);
    setShowClass(settingsData.showClass);
    setShowAssignment(settingsData.showAssignment);
    setShowTeacher(settingsData.showTeacher);
  }, [teacherNameData, initialInstructions, dueDate, settingsData]);

  useEffect(() => {
    setHeaderOptions((iniOptions) =>
      iniOptions.map((item) => {
        if (item.id === 'hideName') {
          return { ...item, visible: settingsData.showName };
        } else if (item.id === 'hideClass') {
          return { ...item, visible: settingsData.showClass };
        } else if (item.id === 'hideAssignment') {
          return { ...item, visible: settingsData.showAssignment };
        } else if (item.id === 'hideTeacher') {
          return { ...item, visible: settingsData.showTeacher };
        } else {
          return item;
        }
      })
    );
  }, [settingsData]);

  useEffect(() => {
    if (gotoId !== null) {
      // Find the corresponding question element using the gotoId (question index)
      const questionElement = questionsContainerRef.current.querySelector(`#question-${gotoId}`);
      if (questionElement) {
        // Scroll to the question element
        questionElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [gotoId]);

  return (
    <>
      <div className="print-content-container">
        <div>
          <div className="print-content">
            <div
              className={`content-print ${fontStyleClass} content-print${fontSizeData}`}
              ref={questionsContainerRef}>
              <div className="header-options-wrapper no-change" id="header-options">
                <div className="position-relative">
                  <div className="header-options expand d-flex flex-lg-shrink-0 align-items-center">
                    <span>Header Options</span>
                    <div
                      onClick={() => {
                        handleHeaderOptions();
                      }}>
                      {showHeaderOptions ? (
                        <FontAwesomeIcon icon={faMinus} className="expand-icon" />
                      ) : (
                        <FontAwesomeIcon icon={faPlus} className="expand-icon" />
                      )}
                    </div>
                  </div>
                  {showHeaderOptions && (
                    <div className="header-options-dropdown show">
                      <ul>
                        {headerOptions.map((item, index) => (
                          <li
                            className="dropdown-item cursor-pointer"
                            key={`layout${index}`}
                            onClick={() => {
                              handleHeaderMenuItem(item.id);
                            }}>
                            {item.visible ? `Hide ${item.name}` : `Show ${item.name}`}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="name-slip">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    {showName && (
                      <div>
                        <label className="form-label">Name:</label>
                        <input className="input-name" readOnly></input>
                      </div>
                    )}
                    {showAssignment && (
                      <div>
                        <div className="d-flex gap-2 align-items-center">
                          <label>
                            Assignment:{' '}
                            <span className={`content-print${fontSizeData} fw-bold mx-2`}>
                              {assignmentName}
                            </span>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {showClass && (
                      <div>
                        <label className="form-label">Class/Period:</label>
                        <input className="input-name" readOnly></input>
                      </div>
                    )}
                    {showTeacher && (
                      <div className="d-flex gap-2 align-items-center">
                        <label>Teacher:</label>
                        <div>
                          <input
                            className={`form-control content-print${fontSizeData} fw-bold ${
                              showHeaderOptions
                                ? 'show-box'
                                : `${teacherNameValue?.length > 0 ? 'teacher-edit' : 'd-none'}`
                            }`}
                            value={teacherNameValue?.length > 0 ? teacherNameValue : ''}
                            onChange={handleTeacherEdit}
                            readOnly={teacherNameValue?.length > 0 && !showHeaderOptions}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  {(showHeaderOptions || dueDateValue?.length > 0) && (
                    <div className="d-flex gap-2 align-items-center my-2">
                      <label className="col-2">Assignment Due Date:</label>
                      <input
                        className={`form-control content-print${fontSizeData} fw-bold ${
                          showHeaderOptions
                            ? 'show-box'
                            : `${dueDateValue?.length > 0 ? 'teacher-edit' : 'd-none'}`
                        }`}
                        value={dueDateValue?.length ? dueDateValue : ''}
                        onChange={handleDueDateEdit}
                        readOnly={dueDateValue?.length > 0 && !showHeaderOptions}
                      />
                    </div>
                  )}
                  {(showHeaderOptions || instructionsValue?.length > 0) && (
                    <div className="d-flex gap-2 align-items-center">
                      <label className="col-2">Instructions:</label>
                      <textarea
                        className={`form-control content-print${fontSizeData} fw-bold ${
                          showHeaderOptions
                            ? 'show-box'
                            : `${instructionsValue?.length > 0 ? 'teacher-edit' : 'd-none'}`
                        }`}
                        value={instructionsValue?.length > 0 ? instructionsValue : ''}
                        onChange={handleInstructionsEdit}
                        readOnly={instructionsValue?.length > 0 && !showHeaderOptions}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div id="question-details">
                {questionDetails.map((item, index) => (
                  <div
                    className="question-layout d-flex align-items-start justify-content-between"
                    key={`question-${index}`}
                    id={`question-${item.questionId}`}>
                    <div className="col-lg-10">
                      <div className="d-flex">
                        <div>{index + 1}. </div>
                        {item.question != null && (
                          <div dangerouslySetInnerHTML={{ __html: item.question?.question }}></div>
                        )}
                        {item.blockedText != null && item.blockedText.length > 0 && (
                          <div
                            className="fw-bold text-danger"
                            dangerouslySetInnerHTML={{ __html: item.blockedText }}></div>
                        )}
                      </div>
                      {item.type === 'MC' && (
                        <div className="mcAnswer-content">
                          <img src={item.question?.resources[0]} />
                          <ul className={`${MCSpacingClass} ${MCStylingClass}`}>
                            {item.question?.mcAnswer.length > 0 &&
                              item.question?.mcAnswer?.map((answer, indexValue) => (
                                <li
                                  key={`ans${indexValue}`}
                                  dangerouslySetInnerHTML={{
                                    __html: answer.answer.replace(/<p>/g, '').replace(/<\/p>/g, '')
                                  }}></li>
                              ))}
                          </ul>
                        </div>
                      )}
                      {item.type === 'CR' && (
                        <div
                          dangerouslySetInnerHTML={{ __html: item.question?.sampleAnswer }}></div>
                      )}
                      {item.type === 'Fill-in' && (
                        <div dangerouslySetInnerHTML={{ __html: item.question?.answer }}></div>
                      )}
                      <div className="d-flex align-items-center gap-2 d-none">
                        <label className="form-label">Answer:</label>
                        <div className="answer-box"></div>
                      </div>
                    </div>
                    <div className="mega-dropdown-btn no-change" id="mega-dropdown-button">
                      <div className="expand d-flex align-items-center">
                        <span>Question Layout</span>
                        <Dropdown>
                          <Dropdown.Toggle id="toggle" disabled={true}>
                            <div
                              onClick={() => {
                                handleQuestionLayout();
                              }}>
                              {showQuestionLayout ? (
                                <FontAwesomeIcon icon={faMinus} className="expand-icon" />
                              ) : (
                                <FontAwesomeIcon icon={faPlus} className="expand-icon" />
                              )}
                            </div>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="more-dropdown">
                            {questionLayout.map((item, index) => (
                              <Dropdown.Item
                                key={`layout${index}`}
                                onClick={() => {
                                  handleMenuItem();
                                }}>
                                {item.name}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="answerkey-content">
                <h4 className={answerKeyClass}>Answer Key For : {assignmentName}</h4>
                <div className={answerKeyClass}>
                  {questionDetails.map((item, index) => (
                    <div
                      key={`questionDetails${index}`}
                      className={answerKeyClass === 'd-flex flex-wrap' ? 'answerKey-data' : ''}>
                      <div className="d-flex">
                        <h5>{`Q${index + 1} :`}</h5>
                        <span>
                          {item.type === 'MC' &&
                            item.question?.mcAnswer?.map((answer, indexValue) => {
                              if (answer.isCorrect === 1) return indexValue + 1;
                            })}
                          {item.type === 'CR' && (
                            <>
                              <span>Constructed Response:</span>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.question?.sampleAnswer
                                }}></div>
                            </>
                          )}
                          {item.type === 'Fill-in' &&
                            item.question?.mcAnswer?.map((answer) => {
                              <div dangerouslySetInnerHTML={{ __html: answer.answer }}></div>;
                            })}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="print-content-container d-none">
          <div id="print-assignment-questions">
            <div className="print-content">
              <div className={`content-print ${fontStyleClass} content-print${fontSizeData}`}>
                <div className="name-slip">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      {showName && (
                        <div>
                          <label className="form-label">Name:</label>
                          <input className="input-name" readOnly></input>
                        </div>
                      )}
                      {showAssignment && (
                        <div>
                          <div className="text-align-center">
                            <label>
                              Assignment:{' '}
                              <span className={`content-print${fontSizeData} fw-bold mx-2`}>
                                {assignmentName}
                              </span>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      {showClass && (
                        <div>
                          <label className="form-label">Class/Period:</label>
                          <input className="input-name" readOnly></input>
                        </div>
                      )}
                      {showTeacher && (
                        <div className="d-flex gap-2 align-items-center">
                          <label>
                            Teacher:{' '}
                            <span className={`content-print${fontSizeData} fw-bold mx-1`}>
                              {teacherNameValue}
                            </span>
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    {dueDateValue?.length > 0 && (
                      <div className="d-flex gap-2 align-items-center my-2">
                        <label>
                          Assignment Due Date:{' '}
                          <span className={`content-print${fontSizeData} fw-bold mx-1`}>
                            {dueDateValue}
                          </span>
                        </label>
                      </div>
                    )}
                    {instructionsValue?.length > 0 && (
                      <div className="d-flex gap-2 align-items-center">
                        <label>
                          Instructions:{' '}
                          <span className={`content-print${fontSizeData} fw-bold mx-1`}>
                            {instructionsValue}
                          </span>
                        </label>
                      </div>
                    )}
                  </div>
                </div>
                <div id="question-details">
                  {questionDetails.map((item, index) => (
                    <div
                      className="question-layout-print d-flex align-items-start justify-content-between"
                      key={`question-print-${index}`}
                      id={`question-print-${item.questionId}`}>
                      <div className="col-lg-10">
                        <div className="d-flex">
                          <div>{index + 1}. </div>
                          {item.question != null && (
                            <div
                              dangerouslySetInnerHTML={{ __html: item.question?.question }}></div>
                          )}
                          {item.blockedText != null && item.blockedText.length > 0 && (
                            <div
                              className="fw-bold text-danger"
                              dangerouslySetInnerHTML={{ __html: item.blockedText }}></div>
                          )}
                        </div>
                        {item.type === 'MC' && (
                          <div className="mcAnswer-content">
                            <img src={item.question?.resources[0]} />
                            <ul className={`${MCSpacingClass} ${MCStylingClass}`}>
                              {item.question?.mcAnswer !== [] &&
                                item.question?.mcAnswer?.map((answer, indexValue) => (
                                  <li
                                    key={`ans${indexValue}`}
                                    dangerouslySetInnerHTML={{
                                      __html: answer.answer
                                        .replace(/<p>/g, '')
                                        .replace(/<\/p>/g, '')
                                    }}></li>
                                ))}
                            </ul>
                          </div>
                        )}
                        {item.type === 'CR' && (
                          <div
                            dangerouslySetInnerHTML={{ __html: item.question?.sampleAnswer }}></div>
                        )}
                        {item.type === 'Fill-in' && (
                          <div dangerouslySetInnerHTML={{ __html: item.question?.answer }}></div>
                        )}
                        <div className="d-flex align-items-center gap-2 d-none">
                          <label className="form-label">Answer:</label>
                          <div className="answer-box"></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="answerkey-content">
                  <h4 className={answerKeyClass}>Answer Key For : {assignmentName}</h4>
                  <div className={answerKeyClass}>
                    {questionDetails.map((item, index) => (
                      <div
                        key={`questionDetails${index}`}
                        className={answerKeyClass === 'd-flex flex-wrap' ? 'answerKey-data' : ''}>
                        <div className="d-flex">
                          <h5>{`Q${index + 1} :`}</h5>
                          <span>
                            {item.type === 'MC' &&
                              item.question?.mcAnswer?.map((answer, indexValue) => {
                                if (answer.isCorrect === 1) return indexValue + 1;
                              })}
                            {item.type === 'CR' && (
                              <>
                                <span>Constructed Response:</span>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.question?.sampleAnswer
                                  }}></div>
                              </>
                            )}
                            {item.type === 'Fill-in' &&
                              item.question?.mcAnswer?.map((answer) => {
                                <div dangerouslySetInnerHTML={{ __html: answer.answer }}></div>;
                              })}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

StandardPrintingContent.propTypes = {
  assignmentName: PropTypes.string,
  fontStyleData: PropTypes.string,
  fontSizeData: PropTypes.number,
  mcSpacingData: PropTypes.number,
  mcStylingData: PropTypes.number,
  questionDetails: PropTypes.array,
  teacherName: PropTypes.string,
  answerKey: PropTypes.number,
  updateSettings: PropTypes.func,
  initialInstructions: PropTypes.string,
  teacherNameData: PropTypes.string,
  dueDate: PropTypes.string,
  settingsData: PropTypes.object,
  gotoId: PropTypes.number
};

export default StandardPrintingContent;
